import { type ActionCreator, type Dispatch } from "redux"
import { UtilityService } from "~Shared/services"
import { type ThunkResult } from "~Shared/store"
import { type FetchApiVersionAction, FetcherActionTypes, type LoadedAction, type ResetFetchFlagAction, type StartLoadingAction } from "~Shared/store/actions/fetcher/fetcherTypes"

export const setLoading = () => (dispatch: Dispatch) => {
    const StartLoadingAction: StartLoadingAction = {
        type: FetcherActionTypes.START_LOADING,
        hasLoaded: false,
    }

    dispatch(StartLoadingAction)
}

export const setHasLoaded = (): LoadedAction => ({
    type: FetcherActionTypes.LOADED,
    hasLoaded: true,
})

export const resetFetchFlag = (): ResetFetchFlagAction => ({
    type: FetcherActionTypes.RESET_FETCH_FLAG,
    isCancelled: false,
})

export const fetchApiVersion: ActionCreator<ThunkResult<string>> = () => async (dispatch: Dispatch) => {
    const apiVersion = await UtilityService.getApiVersion()

    const FetchApiVersionAction: FetchApiVersionAction = {
        type: FetcherActionTypes.FETCH_API_VERSION,
        apiVersion,
    }

    dispatch(FetchApiVersionAction)

    return apiVersion
}
